export enum KindOfRoundChoices{
    NORMAL = "Normal",
    MULTIPLE_CHOICE = "MultipleChoice",
    VIDEO = "Video",
    PHOTO = "Photo"
}